/**
 * @fileoverview GET handler for the "/company_settings/subscriptions_and_usage" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { companySettingsSubscriptionsAndUsage } from "./constants";
import type { CompanySettingsSubscriptionsAndUsageResult } from "./types";

export const getCompanySettingsSubscriptionsAndUsage = reactQueryFetcherAdapter(
  companySettingsSubscriptionsAndUsage,
  (
    signal: AbortSignal,
    startDate: number,
    endDate: number
  ): Promise<CompanySettingsSubscriptionsAndUsageResult> => {
    return fetch(
      "/company_settings/subscriptions_and_usage",
      "GET",
      { start: startDate, end: endDate },
      { signal }
    );
  }
);
